/**
 * Generic library for queueing the execution of a series of functions
 */
class Queue {
  constructor(autorun = true) {
    this.autorun = autorun;

    this.queue = [];
    this.running = false;
  }

  /**
   * Returns if the queue has items or not.
   * @returns {Boolean} Whether the queue has items
   */
  isEmpty() {
    return this.queue.length > 0;
  }

  /**
   * Adds an item to the queue. The item will be used as payload to the callback function when the queue starts.
   * @param   {function}  callback
   * @param   {object}    item
   * @param   {function}  onSuccess
   * @param   {function}  onError
   */
  add(callback, payload, onSuccess, onError) {
    this.queue.push({ callback, payload, onSuccess, onError });
    // When adding an item autostart the queue
    if (this.autorun && !this.running) {
      this.start();
    }
  }

  /**
   * Start running the queue
   */
  start() {
    this.running = true;
    this.startNext();
    this.running = false;
  }

  /**
   * Start the next item in the queue
   */
  async startNext() {
    // In case there are items in the queue get the 1st one
    if (this.queue.length !== 0) {
      const { callback, payload, onSuccess, onError } = this.queue.shift();
      callback(payload)
        .then(response => {
          onSuccess(response);
          this.startNext();
        })
        .catch(error => {
          console.log('startNext::error', error.response);
          onError(error.response);
        });
      // try {
      //   const response = await callback(payload);
      //   onSuccess(response);
      //   this.startNext();
      // } catch (e) {
      //   console.error('queue::startNext(): Error caught:', e);
      //   onError(e);
      // }
    }
  }
}

export default Queue;
